import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import './style/MagneticCursor.css';

const CustomCursor = () => {
    const dotRef = useRef(null);
    const ringRef = useRef(null);

    useGSAP(() => {
        const dot = dotRef.current;
        const ring = ringRef.current;

        // تجهيز أداة quickTo للأداء الخارق (تحديث مباشر للـ transforms)
        const xDotTo = gsap.quickTo(dot, "x", { duration: 0.08, ease: "power3.out" });
        const yDotTo = gsap.quickTo(dot, "y", { duration: 0.08, ease: "power3.out" });

        const xRingTo = gsap.quickTo(ring, "x", { duration: 0.4, ease: "power3.out" });
        const yRingTo = gsap.quickTo(ring, "y", { duration: 0.4, ease: "power3.out" });

        // طرح نصف قطر الدائرة ليكون المؤشر في المنتصف تماماً
        gsap.set(dot, { xPercent: -50, yPercent: -50 });
        gsap.set(ring, { xPercent: -50, yPercent: -50 });

        // تتبع حركة الماوس في الشاشة
        const onMouseMove = (e) => {
            xDotTo(e.clientX);
            yDotTo(e.clientY);
            xRingTo(e.clientX);
            yRingTo(e.clientY);
        };

        window.addEventListener("mousemove", onMouseMove);

        // 🧲 منطق الجذب المغناطيسي للأزرار
        const magneticButtons = document.querySelectorAll('.magnetic-button');

        magneticButtons.forEach((btn) => {
            const onBtnMouseMove = (e) => {
                const rect = btn.getBoundingClientRect();
                // حساب نقطة المنتصف للزرار
                const btnCenterX = rect.left + rect.width / 2;
                const btnCenterY = rect.top + rect.height / 2;

                // حساب مسافة بعد الماوس عن منتصف الزرار
                const distanceX = e.clientX - btnCenterX;
                const distanceY = e.clientY - btnCenterY;

                // شد الزرار بنسبة 35% باتجاه الماوس
                gsap.to(btn, {
                    x: distanceX * 0.35,
                    y: distanceY * 0.35,
                    duration: 0.3,
                    ease: "power2.out"
                });

                // شد الدائرة الخارجية للماوس لتلتصق بالزرار وتكبر
                ring.classList.add('cursor-hovering');
                xRingTo(btnCenterX + distanceX * 0.15);
                yRingTo(btnCenterY + distanceY * 0.15);
            };

            const onBtnMouseLeave = () => {
                // إعادة الزرار لمكانه الطبيعي فور خروج الماوس
                gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: "elastic.out(1, 0.3)" });
                ring.classList.remove('cursor-hovering');
            };

            btn.addEventListener('mousemove', onBtnMouseMove);
            btn.addEventListener('mouseleave', onBtnMouseLeave);
        });

        // تنظيف الأحداث عند الخروج من الصفحة
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
        };
    }, []);

    return (
        <>
            <div ref={dotRef} className="cursor-dot" />
            <div ref={ringRef} className="cursor-ring" />
        </>
    );
};

export default CustomCursor;